import { Paper, styled } from "@mui/material"

export const TableWrapperPaper = styled(Paper)({
  margin: "0px 24px",
  display: "flex",
  flexDirection: "column",
  borderRadius: "4px",
  boxShadow: "0px 2px 8px #00000022",
  height: "100%",
  mb: "5px",
})
